<section class="py-5 hero-gradient-cc-instructions">
  <div class="container">
    <div class="row gx-5">
      <div class="col-12 col-md-6 d-flex flex-column justify-content-center text-white">
        <h1 class="text-white fw-bold h1">
          Logging in to Adobe Express
        </h1>

        <p class="mt-3 text-white fs-5">
          Adobe Express can be accessed via
          desktop browser <!-- Fix orphan --><span class="d-inline-block">and mobile devices.</span>
        </p>

        <!-- App Store / Play Badges -->
        <div class="d-flex flex-column flex-md-row justify-content-start mt-2">
          <a href="https://apps.apple.com/us/app/adobe-express-graphic-design/id1051937863">
            <img ngSrc="assets/images/adobe/badges/apple-store-badge.svg"
                 alt="Download on the App Store"
                 width="144"
                 height="48">
          </a>

          <a href="https://play.google.com/store/apps/details?id=com.adobe.spark.post"
             class="ms-0 ms-md-3 mt-3 mt-md-0">
            <img ngSrc="assets/images/adobe/badges/google-play-badge.png"
                 alt="Get it on Google Play"
                 width="162"
                 height="48">
          </a>
        </div>
      </div>

      <!-- Instructions List -->
      <div class="col-12 col-md-6 fs-5 my-5 my-md-4">
        <p class="fw-bold fs-5 text-white">To access Adobe Express from your browser:</p>

        <!-- This mainly using custom styles for the list -->
        <ol class="instructions-list text-white ps-0">
          <li>
            <span>
              Activate your Adobe Express license.
            </span>
          </li>

          <li>
            <span>
              Visit
              <a href="https://new.express.adobe.com/a/utah.edu"
                 target="_blank"
                 class="text-white">
                new.express.adobe.com/a/utah.edu
              </a>
            </span>
          </li>
          <li>
            <span>
              Enter your University of Utah email (uNID&#64;umail.utah.edu) in the email address field and select Continue.
            </span>
          </li>
          <li>
            <span>
              You will be re-directed to the University of Utah authentication page. Enter your uNID and password.
            </span>
          </li>
          <li>
            <span>
              You will be taken to the Adobe Express application.
            </span>
          </li>
          <li>
            <span>
              For additional questions,
              contact Digital Learning Technologies at
              <a href="mailto:classhelp@utah.edu" class="text-white">
                classhelp&#64;utah.edu
              </a>
            </span>
          </li>
        </ol>
      </div>
    </div>
  </div>
</section>
